import { z } from "zod/v4";

export const clubSkillLevelSchema = z.object({
	id: z.string().uuid(),
	club_id: z.string().uuid(),
	name: z.string(),
	sort_order: z.number().int(),
	created_at: z.coerce.date(),
});

export const createSkillLevelSchema = z.object({
	name: z.string().min(1, "Name is required"),
	sort_order: z.number().int().optional(),
});

export const updateSkillLevelSchema = z.object({
	name: z.string().min(1).optional(),
	sort_order: z.number().int().optional(),
});
